import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    Text3,
    Text2,
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    Text5,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { formatMobileNumber } from '../../../../../utils/dataTransformation/unitsConversion';
import { sendContactVerificationOTP } from '../../../../../services/CustomerService';
import ContactsValidate from '../validateVerify';
import UpdatePersonalData from '../update';
import { AxiosError } from 'axios';
import HeaderProfile from '../../../../../components/HeaderProfile';

export interface ContactsVerifyInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    flowDesktop?: string;
    fromOnboardingDesktop?: any;
    contactDesktop?: any;
}

const ContactsVerify: React.FC<ContactsVerifyInterface> = ({
    fromDesktop,
    setComponentSelected,
    flowDesktop,
    fromOnboardingDesktop,
    contactDesktop,
}) => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const [params] = useSearchParams();
    const contact = fromDesktop ? contactDesktop : params.get('contact')!;
    const flow = fromDesktop ? flowDesktop : params.get('flow')!;

    const sendToNative = (url: string, description: string, type: string, title?: string, err?: any) => {
        const storage = {};
        const feedbackData = {
            err: err,
        };
        const queryParams = {
            state: description,
            errorCode: err ? err.id : '',
            contact: contact,
            flow: flow,
        };
        if (type === 'feedback-error') {
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(url, { state: feedbackData });
            }
        } else {
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(url + '?flow=' + flow + '&contact=' + contact);
            }
        }
    };

    const verificationOTPSend = () => {
        sendContactVerificationOTP(contact)
            .then(() => {
                sendToNative(
                    '/contacts/validate',
                    '',
                    'modeFlow-backgroundBlue',
                    flow === 'mobile' ? 'Verificar móvil de contacto' : 'Verificar dirección de email',
                );
            })
            .catch((error: AxiosError) => {
                sendToNative('/escalation/otp/feedback', 'ERROR', 'feedback-error', '', setInfoError(error));
            });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (windowWidth >= 768) {
        return (
            <div className='ContactsVerify-page'>
                <HeaderProfile
                    title={flow === 'mobile' ? t('personalDataUpdateMobileTitle') : t('personalDataUpdateEmailTitle')}
                    breadcrumbs={[
                        { title: t('profileTitle'), url: '/profile' },
                        { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                    ]}
                />
                <div className='ContactsVerify-page__content'>
                    <div className='ContactsVerify-page__content-title'>
                        <Text5 color={skinVars.colors.textPrimary}>
                            {flow === 'mobile' ? t('contactVerifiedTitleContact') : t('contactVerifiedTitleEmail')}
                        </Text5>
                    </div>
                    <div className='ContactsVerify-page__content-text1'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {`${t('descriptionVerifyText1')}${
                                flow === 'mobile' ? formatMobileNumber(contact) : contact
                            }${t('descriptionVerifyText2')}`}
                        </Text2>
                    </div>
                    <div className='ContactsVerify-page__content-text2'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {t('descriptionVerifyText3')}
                        </Text2>
                    </div>
                    <div className='ContactsVerify-page__content-btn'>
                        <ButtonPrimary
                            onPress={() => {
                                verificationOTPSend();
                            }}
                        >
                            {t('continue')}
                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='ContactsVerify-page'>
                <HeaderProfile
                    title={flow === 'mobile' ? t('personalDataUpdateMobileTitle') : t('personalDataUpdateEmailTitle')}
                    breadcrumbs={[
                        { title: t('profileTitle'), url: '/profile' },
                        { title: t('personalDataTitle2'), url: '/profile/personal' },
                    ]}
                />
                <div className='ContactsVerify-page__content'>
                    <ButtonFixedFooterLayout
                        button={
                            <ButtonPrimary
                                onPress={() => {
                                    verificationOTPSend();
                                }}
                            >
                                {t('buttonReceiveCode')}
                            </ButtonPrimary>
                        }
                    >
                        <div className='ContactsVerify-page__content-title'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {flow === 'mobile' ? t('contactVerifiedTitleContact') : t('contactVerifiedTitleEmail')}
                            </Text3>
                        </div>
                        <div className='ContactsVerify__content-text1'>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {`${t('descriptionVerifyText1')}${
                                    flow === 'mobile' ? formatMobileNumber(contact) : contact
                                }${t('descriptionVerifyText2')}`}
                            </Text2>
                        </div>
                        <div className='ContactsVerify__content-text2'>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {t('descriptionVerifyText3')}
                            </Text2>
                        </div>
                    </ButtonFixedFooterLayout>
                </div>
            </div>
        );
    }
};

export default ContactsVerify;
